<template>
    <headerSearch></headerSearch>
    <div class="w1440 personal_center">
        <div class="flex-box col90 ptb10 page_location">
            当前位置：
            <router-link class="col04" to="/BaseInfo">用户中心<span class="plr5">/</span></router-link>
            <router-link class="col04" to="/ServiceTerm">服务条款<span class="plr5">/</span></router-link>
            <div class="now_page">{{ title }}</div>
        </div>
        <div class="flex-box flex-col-start">
            <personal-nav :firstIndex="6" :secondIndex="-1"></personal-nav>
            <div class="ml10 flex-grow-1 part_r">
                <div class="content">
                    <div v-html="agreement"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PersonalNav from "../../../components/PersonalNav.vue";
import { useHead } from '@unhead/vue';
import { onMounted } from "vue";
import { useRoute } from "vue-router";
export default {
    setup() {
        const route = useRoute(); // 获取当前路由信息
        console.log(route)
        onMounted(() => {
            useHead({
                title: route.query.name + '-小狮优选' || "条款详情-小狮优选",
                meta: [
                    { name: "description", content: "This is my page description" },
                    { property: "og:title", content: "My Page Title" },
                    { property: "og:description", content: "This is my page description" },
                    { property: "og:url", content: "https://example.com/my-page" },
                    { property: "og:image", content: "https://example.com/my-image.jpg" },
                ],
                link: [{ rel: "canonical", href: "https://example.com/my-page" }],
            })
        })
    },
    components: {
        PersonalNav,
    },
    data() {
        return {
            agreement: '',
        };
    },
    created() {
        this.getDetail(this.$route.query.id);
    },
    watch: {
        '$route.query': {
            immediate: true,
            handler(newId) {
                this.getDetail(newId.id);
                this.title = newId.name;
            }
        }
    },
    methods: {
        getDetail(id) {
            this.$api.getAgreement({ id: id }).then(res => {
                this.agreement = res.data.content;
            }).catch(error => {
                console.error('获取服务条款失败:', error);
            });
        }
    },
};
</script>

<style lang="less" scoped>

.part_r {
    background: #fff;
    padding: 44px 24px;
}

.part_r .content {
    padding: 0 20px;
    max-height: 100%;
    overflow-y: scroll;
}

.part_r .content::-webkit-scrollbar {
    width: 8px;
    height: 20px;
    display: block;
}

.part_r .content::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 10px;
}

.part_r .content::-webkit-scrollbar-thumb {
    background: rgba(18, 117, 255, .2);
    border-radius: 2px;
}

.part_r .content::-webkit-scrollbar-thumb:hover {
    background: rgba(18, 117, 255, .2);
}
</style>
